import { IChangeContractCardDTO } from 'modules/customer/domain/dtos';
import { ICustomerCardsRepository } from 'modules/customer/domain/repositories';
import { UseCaseError } from 'shared/domain/errors';
import { getCardFlagFrom } from 'shared/domain/helpers';

export class ChangeContractCardUseCase {
  constructor(private customerCardsRepository: ICustomerCardsRepository) {}

  public async execute({ contractId, card }: IChangeContractCardDTO) {
    const flag = getCardFlagFrom(card.number);

    if (!flag) throw new UseCaseError('Unrecognized flag');

    return this.customerCardsRepository.update({
      process: 'CONTRACT',
      contractId,
      chargePendencies: true,
      card: {
        ...card,
        flag,
      },
    });
  }
}
